import ConsumerPageSettingPanel from "./consumerPageSettingPanel.container";

export default ConsumerPageSettingPanel;
